import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Loading } from "../../../components/Loading/Loading";
import { Toast } from "primereact/toast";
import { dataUserSession } from "../../../utilities/dataSession";
import P300Overview from "./P300Overview";
import P300List from "./P300List";
import P300Search from "./P300Search";
import { P300BudgetList, P300DashboardList, P300GetDataChart } from "../../../service/300/P300Service";
import "../../../components/DataTable/DataTable.css";
import P300Chart from "./P300Chart";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P300() {

    const history = useHistory();
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);
    //Dashboard
    const [dataDashboard, setDataDashboard] = useState({
        "totalContract": 0,
        "totalPipeLength": 0,
        "totalAmount": 0,
        "pendingAmount": 0,
    });
    //DataTable
    const [dataTable, setDataTable] = useState([]);
    const [searchData, setSearchData] = useState({
        "budgetType": "",
        "userId": dataUserSession() ? dataUserSession().userId : "",
    });

    const [dataGenList, setDataGenList] = useState([]);
    const [sentGen] = useState({
        "userId": dataUserSession() ? dataUserSession().userId : "",
    });

    const [sentChart, setSentChart] = useState({
        "budgetType": "",
        "userId": dataUserSession() ? dataUserSession().userId : "",
    });

    const [dataChart, setDataChart] = useState({
        seriesList: [],
        valList1: [],
        valList2: []
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state && history.location.state.dataSrh) {
                setSearchData({
                    ...searchData,
                    ...history.location.state.dataSrh,
                });
            }
            
        } else {
            history.push("/login");
        }
    }, []);

    const onP300GetDataChart = () => {
        setLoading(true);
        P300GetDataChart(sentChart).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let seriesList = [];
                    let valList1 = [];
                    let valList2 = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });

                        seriesList.push(element.branchName)
                        valList1.push(element.value1)
                        valList2.push(element.value2)

                        index++;
                    });
                    setDataChart({ data: temp, seriesList, valList1, valList2 });
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };


    const onP300DashboardList = () => {
        setLoading(true);
        P300DashboardList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res != undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });

                        if (index === 1) {
                            setDataDashboard({
                                "totalContract": element.totalContract,
                                "totalPipeLength": element.totalPipeLength,
                                "totalAmount": element.totalAmount,
                                "pendingAmount": element.pendingAmount,
                            })
                        }

                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const onP300BudgetList = () => {
        P300BudgetList(sentGen).then(
            (res) => {
                // console.log(res)
                if (res != undefined) {
                    let temp = [];
                    let index = 1;
                    temp.push({ index: 0, budgetTypeCode: "", budgetTypeDesc: "เลือก" })
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });

                    setDataGenList(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setErrData(err)
            }
        );
    };

    useEffect(() => {
        // console.log('searchData ',searchData);
        if (searchData && searchData.budgetType !== '') {
            onP300GetDataChart();
        }
        onP300DashboardList();
        onP300BudgetList();
    }, [searchData]);


    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onRowClick = (e) => {
        if (e && e.data) {
            history.push({
                pathname: '301',
                state: {
                    branchCode: e.data.branchCode
                },
            });
        }
    }

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            {/* <div className="p-grid crud-demo"> */}
            <Toast ref={toast} position="top-right" style={{ width: 'auto' }} />
            {/* <div className="card"> */}
            {/* <Chip label={" ผู้รับเหมา : " + fullName} icon="pi pi-user" className="p-mr-2 p-mb-2" style={{ fontSize: "1.5rem" }} /> */}
            <br />
            <P300Overview dataDashboard={dataDashboard}
            //onClickPendingOrder={onClickPendingOrder} onClickPendingRequest={onClickPendingRequest} 
            />
            <br />
            <div className="card" style={{ paddingLeft: '0rem', paddingRight: '0rem' }}>
                <P300Search
                    dataList={dataGenList}
                    data={searchData}
                    setData={setSearchData}
                    setDataChart={setSentChart}

                />
                <P300List dataTable={dataTable} onRowClick={onRowClick} />
            </div>
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-lg-1"></div>
                <div className="p-col-12 p-lg-10">
                    {
                        searchData.budgetType && searchData.budgetType !== '' && (
                            <div className="card">
                                <P300Chart data={dataChart} />
                            </div>
                        )
                    }
                </div>
                <div className="p-col-12 p-lg-1"></div>
            </div>
            {/* </div> */}
            {/* </div> */}
        </>
    );
}
